export const MILLISECONDS_IN_MINUTE = 1000 * 60;
export const MILLISECONDS_IN_SECOND = 1000;
export const MILLISECONDS_IN_HOUR = 1000 * 60 * 60;
export const SECONDS_IN_MINUTE = 60;
export const MINUTES_IN_HOUR = 60;
export const HOURS_IN_DAY = 24;
